export default __webpack_public_path__ + "static/media/big_sunglasses.25880777.png";